import { useEffect, useState } from 'react';
import { tickerItems } from '@/mocks/exposure';

const navLinks = [
  { label: '实锤头条', href: '#focus' },
  { label: '证据截图', href: '#screenshot' },
  { label: '聊天记录', href: '#chat' },
  { label: '录音视频', href: '#video' },
  { label: '文件材料', href: '#file' },
  { label: '合集索引', href: '#index' },
  { label: '查证日志', href: '#log' },
];

export default function TopBar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [query, setQuery] = useState('');

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 border-b transition-all ${
        scrolled
          ? 'border-background-200 bg-background-50/95 shadow-sm backdrop-blur'
          : 'border-transparent bg-background-50'
      }`}
    >
      {/* 品牌区 + 导航（厚运营壳） */}
      <div className="mx-auto flex w-full max-w-[1280px] items-center gap-6 px-4 py-3 md:px-6">
        <a href="#top" className="flex shrink-0 items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-lg text-background-50">
            <i className="ri-spy-line" />
          </span>
          <span className="leading-none">
            <span className="block font-serif text-lg font-black tracking-wide text-foreground-900 md:text-xl">
              全网黑料
            </span>
            <span className="mt-1 block text-[10px] tracking-[0.2em] text-foreground-500">
              实锤 · 查证 · 材料持续更新
            </span>
          </span>
        </a>

        <nav className="ml-2 hidden flex-1 items-center gap-1 lg:flex">
          {navLinks.map((l) => (
            <a
              key={l.label}
              href={l.href}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium text-foreground-600 transition hover:bg-primary-50 hover:text-primary-700"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="ml-auto hidden items-center gap-3 md:flex">
          <div className="hidden items-center gap-2 rounded-full border border-background-200 bg-background-50 px-3.5 py-2 lg:flex">
            <i className="ri-search-line text-sm text-foreground-400" />
            <input
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="搜人物 / 事件 / 平台"
              className="w-40 bg-transparent text-sm text-foreground-800 outline-none placeholder:text-foreground-400"
            />
          </div>
          <a
            href="#submit"
            className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition hover:bg-primary-600"
          >
            <i className="ri-add-line text-base leading-none" />
            我要投稿
          </a>
        </div>

        <button
          onClick={() => setMenuOpen((v) => !v)}
          aria-label="展开菜单"
          className="ml-auto flex h-9 w-9 items-center justify-center rounded-md border border-background-200 text-foreground-700 lg:hidden"
        >
          <i className={menuOpen ? 'ri-close-line text-lg' : 'ri-menu-line text-lg'} />
        </button>
      </div>

      {/* 移动端菜单 */}
      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-3 lg:hidden">
          <div className="mb-3 flex items-center gap-2 rounded-full border border-background-200 px-3.5 py-2">
            <i className="ri-search-line text-sm text-foreground-400" />
            <input
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="搜人物 / 事件 / 平台"
              className="w-full bg-transparent text-sm outline-none placeholder:text-foreground-400"
            />
          </div>
          <nav className="grid grid-cols-2 gap-1">
            {navLinks.map((l) => (
              <a
                key={l.label}
                href={l.href}
                onClick={() => setMenuOpen(false)}
                className="whitespace-nowrap rounded-md px-3 py-2.5 text-sm font-medium text-foreground-700 transition hover:bg-primary-50 hover:text-primary-700"
              >
                {l.label}
              </a>
            ))}
          </nav>
          <a
            href="#submit"
            onClick={() => setMenuOpen(false)}
            className="mt-3 flex items-center justify-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-50"
          >
            <i className="ri-add-line text-base leading-none" />
            我要投稿
          </a>
        </div>
      )}

      {/* 压顶更新条 */}
      <div className="relative flex items-stretch overflow-hidden border-t border-primary-800 bg-foreground-950 text-background-100">
        <div className="z-10 flex shrink-0 items-center gap-2 bg-primary-500 px-3 py-2 text-background-50 md:px-4">
          <span className="relative flex h-2 w-2">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-background-50/70" />
            <span className="relative inline-flex h-2 w-2 rounded-full bg-background-50" />
          </span>
          <span className="whitespace-nowrap text-xs font-bold tracking-wide md:text-sm">材料更新中</span>
        </div>
        <div className="relative flex-1 overflow-hidden">
          <div className="animate-marquee flex w-max items-center">
            {[...tickerItems, ...tickerItems].map((t, i) => (
              <span key={i} className="flex items-center whitespace-nowrap px-6 text-xs md:text-sm">
                <i className="ri-flashlight-line mr-2 text-accent-400" />
                {t}
                <span className="ml-6 text-primary-400">|</span>
              </span>
            ))}
          </div>
        </div>
        <a
          href="#log"
          className="hidden shrink-0 items-center gap-1 whitespace-nowrap border-l border-primary-700 bg-foreground-900 px-4 text-xs font-medium text-accent-300 transition hover:text-accent-200 md:flex"
        >
          查证日志 <i className="ri-arrow-right-up-line" />
        </a>
      </div>
    </header>
  );
}